module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Trend.js"));
	}, "Trend");
}